import React from 'react';

interface SelectOption {
  value: string;
  label: string;
}

interface InputFieldProps {
  icon: string;
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  type?: 'text' | 'select';
  options?: SelectOption[];
  name?: string;
  containerClass?: string;
  inputClass?: string;
}

export default function InputField({
  icon,
  label,
  placeholder,
  value,
  onChange,
  type = 'text',
  options,
  name,
  containerClass = '',
  inputClass = '',
}: InputFieldProps) {
  return (
    <div className={containerClass}>
      {label && (
        <label className="form-label text-muted small fw-semibold">{label}</label>
      )}
      <div className="input-group">
        <span className="input-group-text bg-white border-end-0 text-muted">
          <i className={icon}></i>
        </span>
        {type === 'select' ? (
          <select
            className={`form-select border-start-0 ps-0 ${inputClass}`}
            value={value}
            onChange={onChange}
            name={name}
          >
            {options?.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ) : (
          <input
            type="text"
            className={`form-control border-start-0 ps-0 ${inputClass}`}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            name={name}
          />
        )}
      </div>
    </div>
  );
}
